import { AgsSpinResponseSchema, AgsWin } from "ags/integration/schema/ags-spin-response-schema";
import { Record } from "appworks/model/gameplay/records/record";
import { Result } from "appworks/model/gameplay/records/results/result";
import { ResultBuilder } from "appworks/server/builders/result-builder";
import { FreespinWinResult } from "slotworks/model/gameplay/records/results/freespin-win-result";

export abstract class AgsResultBuilder implements ResultBuilder {

    constructor(protected evaluationTypeAlias?: string) {}

    public abstract filter(data: any): boolean;

    public abstract build(record: Record, data: any, response: AgsSpinResponseSchema): Result[];

    protected processFreespinData(record: Record, data: AgsWin, result: Result): FreespinWinResult[] {
        const freespinResults = [];
        if (data.freeSpinsAmount > 0) {
            const freespinResult = new FreespinWinResult();
            freespinResult.freespinsWon = data.freeSpinsAmount;
            freespinResults.push(freespinResult);

            result.linkedResult = freespinResult;
            freespinResult.linkedResult = result;
        }

        return freespinResults;
    }
}
